// import App from './App.vue'
import Home from './components/Home.vue'
import SearchPage from './components/SearchPage.vue'
import i18n from '@/plugins/i18n';



const routes = [
      {
        path: '/',
        redirect: `/${i18n.locale}`
      },
      {
        path: '/:lang',
        name: 'question',
        component: Home
      },
      { 
        path: '/:lang/search', 
        component: SearchPage,
        name: "searchPage"
      },
      {
        path: "*",
        redirect: "/"
      }
      
]
export default routes;